export default "__VITE_ASSET__WWdP9xFX__"